import React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { cn } from '@/lib/utils.ts'

const waitTimeToggleVariants = cva(
  'group inline-flex h-[33px] shrink-0 items-start gap-[-1px] rounded-allocated bg-white',
  {
    variants: {
      state: {
        default: '',
        exceedsThreshold: '',
        addMore: '',
      },
    },
    defaultVariants: {
      state: 'default',
    },
  }
)

const checkButtonVariants = cva('flex items-center justify-center self-stretch rounded-l-allocated p-2', {
  variants: {
    state: {
      default: 'border border-green-700 bg-green-500',
      exceedsThreshold: 'border border-orange-500 bg-orange-400',
      addMore: 'border-b border-b-gray-600 bg-[linear-gradient(180deg,rgba(17,25,40,0.78)_0%,#111928_100%)]',
    },
  },
  defaultVariants: {
    state: 'default',
  },
})

const checkIconVariants = cva('h-5 w-6', {
  variants: {
    state: {
      default: 'fill-white',
      exceedsThreshold: 'fill-white',
      addMore: 'fill-gray-400 group-hover:fill-green-400',
    },
  },
  defaultVariants: {
    state: 'default',
  },
})

const addMoreButtonVariants = cva('flex items-center justify-center self-stretch rounded-r-allocated p-2', {
  variants: {
    state: {
      default: 'border-b border-gray-600 bg-[linear-gradient(180deg,rgba(17,25,40,0.78)_0%,#111928_100%)]',
      exceedsThreshold: 'border-b border-gray-600 bg-[linear-gradient(180deg,rgba(17,25,40,0.78)_0%,#111928_100%)]',
      addMore: 'border border-red-500 bg-red-800',
    },
  },
  defaultVariants: {
    state: 'default',
  },
})

const addMoreIconVariants = cva('h-5 w-6', {
  variants: {
    state: {
      default: 'fill-gray-400 group-hover:fill-red-500',
      exceedsThreshold: 'fill-gray-400 group-hover:fill-red-500',
      addMore: 'fill-white',
    },
  },
  defaultVariants: {
    state: 'default',
  },
})

export interface WaitTimeToggleProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof waitTimeToggleVariants> {}

export const WaitTimeToggle = React.forwardRef<HTMLButtonElement, WaitTimeToggleProps>(
  ({ className, state, ...props }, ref) => (
    <button type="button" className={cn(waitTimeToggleVariants({ state, className }))} ref={ref} {...props}>
      <div className={cn(checkButtonVariants({ state }))}>
        <Icons.checkCircle className={cn(checkIconVariants({ state }))} />
      </div>
      <div className={cn(addMoreButtonVariants({ state }))}>
        <Icons.plusCircle className={cn(addMoreIconVariants({ state }))} />
      </div>
    </button>
  )
)
